<script>
export default {
  props: {
    leaderboardData: {
      type: Object,
      required: true,
    },
    leaderboardPosition: {
      type: Number,
      required: true,
    },
    highlight: {
      type: Boolean,
    },
    smallTheme: {
      type: Boolean,
    },
  },
  data() {
    return {
      currencyFormatter: new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
      }),
    }
  },
  computed: {
    getName() {
      return this.leaderboardData.name
    },
    getAddresses() {
      return this.leaderboardData.addresses
    },
    getRankValue() {
      if (this.leaderboardData.isUnit) {
        return this.leaderboardData.rankValue
      }
      return this.currencyFormatter.format(this.leaderboardData.rankValue)
    },
  },
  methods: {},
}
</script>

<template>
  <div :class="{ [$style.container]: true, [$style.highlight]: highlight, [$style.smallTheme]: smallTheme }">
    <div :class="{ [$style.positionIcon]: true, [$style.highlight]: highlight }">
      <h1 class="color-white">{{ leaderboardPosition }}</h1>
    </div>
    <div :class="{ [$style.winnerInfo]: true, [$style.highlight]: highlight }">
      <h3 data-leaderboard-position-name>{{ getName }}</h3>
      <template v-if="!smallTheme">
        <h4 v-for="(address, index) in getAddresses" :key="index">{{ address }}</h4>
      </template>
    </div>
    <div :class="{ [$style.rankValue]: true, [$style.highlight]: highlight }">
      <h3 v-if="highlight">{{ getRankValue }}</h3>
      <p v-if="!highlight" class="button-text color-dark-gray">{{ getRankValue }}</p>
    </div>
  </div>
</template>

<style lang="scss" module>
@import '@design';

.container {
  display: flex;
  color: $light-gray;
  border: 1px solid currentColor;
  border-radius: 16px;

  &.highlight {
    color: $primary-blue;
  }
}

.positionIcon {
  @media (max-width: $lg-breakpoint) {
    width: 35px;
    height: 35px;
    border-radius: 8px;
  }

  flex-shrink: 0;
  width: 56px;
  height: 56px;
  margin: 16px;
  background: $primary-blue;
  border-radius: 16px;

  &.highlight {
    background: $secondary-green;
  }

  h1 {
    @media (max-width: $lg-breakpoint) {
      font-size: 18px;
      line-height: 35px;
    }

    line-height: 56px;
    text-align: center;
    user-select: none;
  }
}

.winnerInfo {
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-right: 5px;
  margin-left: 16px;
  color: $darkest-gray;
  $winner-info: &;

  &.highlight {
    color: $primary-blue;
  }

  h3 {
    @media (max-width: $lg-breakpoint) {
      padding: 16px 0 4px 0;
      font-size: 12px;
    }

    padding: 16px 0;
    margin: 0;
    color: currentColor;
  }

  h4 {
    @media (max-width: $lg-breakpoint) {
      font-size: 12px;
    }

    margin-bottom: 16px;
    color: currentColor;
  }
}

.rankValue {
  display: flex;
  margin: auto 24px auto auto;

  h3 {
    @media (max-width: $lg-breakpoint) {
      font-size: 12px;
      letter-spacing: 0.3px;
    }

    margin: 0;
    color: currentColor;
  }

  p {
    @media (max-width: $lg-breakpoint) {
      font-size: 12px;
    }
  }
}

.smallTheme {
  .positionIcon {
    margin: 8px !important;
  }

  .winnerInfo {
    margin-left: 8px;
    color: $gray;

    h3 {
      @media (max-width: $lg-breakpoint) {
        padding: 0;
        font-size: 12px;
      }

      font-size: 16px;
      line-height: 16px;
    }

    &.highlight {
      color: $primary-charcoal;
    }
  }

  .rankValue {
    > * {
      @media (max-width: $lg-breakpoint) {
        font-size: 12px;
      }

      font-size: 14px;
      line-height: 16px;
      color: $gray;
      letter-spacing: 0.3px;
    }

    &.highlight {
      > * {
        color: $darkest-gray;
      }
    }
  }
}
</style>
